import React from "react";

function RefStrap(component)
{
	return React.forwardRef((props, ref) => React.createElement(component, {innerRef: ref, ...props}));
}

export default RefStrap;